<template>
    <div class="inputHistory" v-show="isShow">
        <input class="titleInput" @keyup.enter="check" v-model="value" />
        <div class="inputHistory-opt">
            <span @click="check" title="保存"><i class="el-icon-check"></i></span>
            <span @click="close" title="取消"><i class="el-icon-close"></i></span>
        </div>
    </div>
</template>

<script>
import {  modifyTitle } from "@/api/ai.js";
import {  encode } from "js-base64";
export default {
    data() {
        return {
          type: '',
        //   original :'',
          value: '',
          id: '',
          isShow: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            document.addEventListener('click', this.handleClick)
        })
    },
    unmounted() {
        document.removeEventListener('click', this.handleClick) 
    },
    methods: {
        handleClick(event) {
            if (['/single' , '/judgeAiEnhance',  '/sourceAiEnhance'].indexOf(this.$route.path) > -1) {
                var parent = this.$el.parentNode
                if (event.target !== parent && !parent.contains(event.target)) {
                    this.isShow = false
                }
            }
        },
        showEdit(item, type) {
            this.original = item.TITLE
            this.value = item.TITLE
            this.type = type
            this.id = item.RECID
            this.isShow = true
            this.$nextTick(() => {
                this.$el.querySelector('.titleInput').focus()
            })
        },
        check() {
            if (!(/^[\s\S]*.*[^\s][\s\S]*$/.test(this.value))) {
                this.$message.error('编辑失败,输入不能为空！') 
                return
            }
            modifyTitle(encode(this.value), this.type, this.id).then(res => {
              if (res.count == 200) {
                if (this.$route.path == '/single') {
                    // 单篇问答特殊处理
                    this.$store.dispatch('singleHistory/modifyTitle', { RECID: this.id, value: this.value})
                } else {
                    const cutItem = this.$parent.allHistory.find(it => it.RECID == this.id)
                    cutItem.TITLE = this.value
                }
                this.isShow = false
                this.$message.success(`你编辑的新名称: ${this.value}`) 
              } else {
                this.isShow = false
                this.$message.error('编辑失败！')   
              }
            }).catch(err => {
              console.log(err)
              this.isShow = false
              this.$message.error('编辑失败！') 
            })
        },
        close() {
            this.isShow = false
        }
    }
}
</script>

<style lang="scss">
.inputHistory{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    border: 1px solid #275ad1;
    border-radius: 4px;
    background: #fff;
    height: 35px;
    line-height: 35px;
    input{
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        background: #fff;
        border-radius: 10px;
        line-height: 40px;
        width: 175px;
        margin-left: 15px;
        padding: 0 2px;
        vertical-align: top;
        margin-top: 0;
        vertical-align: top;
        height: 33px;
        line-height: 33px;
    }
    &-opt{
        position: absolute;
        top:0;
        right:4px;
        color: #999;
        line-height: 33px;
        height: 33px;
        span{
            padding: 2px;
            margin-right: px;
            border-radius :3px;
            &:hover{
                background: rgb(225, 229, 250);
                
                text-align: center;
                i{
                    
                    color: #275ad1
                }
            }
        }
        i{
           font-weight: bold;
            cursor: pointer;
        }
    }
}
</style>